// frontend/src/utils/iconMap.js
import React from 'react';
import {
  SpaRounded as LeafIcon,
  PeopleRounded as UsersIcon,
  AutoAwesomeRounded as SparklesIcon,
  PublicRounded as GlobeIcon,
  FavoriteRounded as HeartIcon,
  ShieldRounded as ShieldIcon,
  EmojiEventsRounded as TrophyIcon,
  StarRounded as StarIcon,
  SentimentSatisfiedAltRounded as SmileIcon,
  FlagRounded as FlagIcon,
  MenuBookRounded as BookIcon,
  CelebrationRounded as CelebrationIcon,
  LocationOnRounded as LocationIcon,
  SchoolRounded as SchoolIcon,
  ExploreRounded as CompassIcon,
  WhatshotRounded as FireIcon
} from '@mui/icons-material';

export const AVAILABLE_VALUE_ICONS = [
  { id: 'Leaf', label: 'Blatt / Natur', Component: LeafIcon },
  { id: 'Users', label: 'Gruppe / Gemeinschaft', Component: UsersIcon },
  { id: 'Sparkles', label: 'Funken / Entwicklung', Component: SparklesIcon },
  { id: 'Globe', label: 'Globus / Weltoffenheit', Component: GlobeIcon },
  { id: 'Heart', label: 'Herz / Zusammenhalt', Component: HeartIcon },
  { id: 'Shield', label: 'Schild / Schutz & Sicherheit', Component: ShieldIcon },
  { id: 'Trophy', label: 'Pokal / Erfolg & Abenteuer', Component: TrophyIcon },
  { id: 'Star', label: 'Stern / Vorbild', Component: StarIcon },
  { id: 'Smile', label: 'Lächeln / Spaß', Component: SmileIcon },
  { id: 'Flag', label: 'Flagge / Pfadfinder', Component: FlagIcon },
  { id: 'Book', label: 'Buch / Lernen', Component: BookIcon },
  { id: 'Celebration', label: 'Feier / Lagerfeuer', Component: CelebrationIcon },
  { id: 'Compass', label: 'Kompass / Orientierung', Component: CompassIcon || LocationIcon },
  { id: 'Fire', label: 'Feuer / Lagerfeuer', Component: FireIcon || SparklesIcon },
  { id: 'Location', label: 'Ort / Natur', Component: LocationIcon },
  { id: 'School', label: 'Bildung / Jugend', Component: SchoolIcon },
];

export const getIconComponent = (iconId, sx = { fontSize: 28 }) => {
  const match = AVAILABLE_VALUE_ICONS.find(i => i.id.toLowerCase() === (iconId || '').toLowerCase());
  const Component = match ? match.Component : LeafIcon;
  return <Component sx={sx} />;
};

export const getColorClasses = (colorType = 'primary') => {
  switch (colorType) {
    case 'secondary':
      return {
        bg: 'bg-secondary-container',
        text: 'text-secondary-onContainer'
      };
    case 'tertiary':
      return {
        bg: 'bg-tertiary-container',
        text: 'text-tertiary-onContainer'
      };
    case 'primary':
    default:
      return {
        bg: 'bg-primary-container',
        text: 'text-primary-onContainer'
      };
  }
};
